import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { warningColor } from "assets/jss/material-dashboard-pro-react";

export const StyledTag = styled(Box)`
  font-size: 10px;
  font-weight: black;
  line-height: 100%;
  border-radius: 999px;
  border: 1px solid ${warningColor[0]};
  color: ${warningColor[0]};
  text-transform: uppercase;
  padding: 4px 8px;
`;

export const Title = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 8px;
  color: black;
  text-decoration: none;
  font-weight: 300;
  margin-top: 20px;
  margin-bottom: 25px;
  min-height: 32px;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;

  width: 100%;
  max-width: 200px;
  font-size: 20px;
`;
